<!-- <header>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 text-left left-side" style="height: 35px;">
                <div style="float:left; position: relative;">
                </div>
                <div style="float:left; position: relative;">
                </div>
            </div>
            <div class="col-md-6 col-sm-6 text-right right-side">
            </div>
        </div>
    </div>
</header> -->
<div class="container-fluid" style="margin-top: 20px;">
    <div class="row">
        <!-- <div class="col-md-6 col-sm-6 text-left left-side">
            <img [src]="[ruta_img + 'peip.jpg']" class="img-fluid" />
        </div>
        <div class="col-md-6 col-sm-6 text-right left-side">
            <img [src]="[ruta_img + 'logoMINEDU.jpg']" class="img-fluid" />
        </div> -->
        <div class="col-md-12 col-sm-12 text-left left-side">
            <img [src]="[ruta_img + 'peip.jpg']" class="img-fluid" />
            <img [src]="[ruta_img + 'logoMINEDU.jpg']" class="img-fluid" />
        </div>        
    </div>
</div>

<!-- <div class="col-md-12 col-sm-12 logos">
    <a href="index.html"><img src="assets/img/newlogo.png" class="img-fluid logo"></a>
    <img src="assets/img/iconMINEDU.svg" class="img-fluid logo">
</div> -->
